import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle2 from "../Particle2";
import Github from "./Github";
import Techstack from "./Techstack";
import lightbulb from "../../Assets/about-min.webp";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container fluid className="about-section">
      <div className="particle-style2"> <Particle2 /> </div>
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col md={7} style={{justifyContent: "center", paddingTop: "20px", paddingBottom: "50px",}}>

            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Developer <strong className="purple">Background</strong>
            </h1>

            <p>
              I am a software engineer with a Computer Science degree from the <a href="https://www.uic.edu/" target="_blank" rel="noreferrer" className="purple"> University of Illinois Chicago</a> and hands-on experience building and supporting software in production. My work spans <b className="purple"> backend </b> (Java, Spring Boot, Node.js, PostgreSQL), <b className="purple"> frontend and mobile </b> (React, React Native, Android), and <b className="purple"> systems </b> (Linux, Docker, AWS, Git).
              <br></br>
              <br></br>
              I have worked close to the business, not just the code. I automated <b className="purple"> billing and reporting workflows </b> from start to finish, handled the healthcare claims process those tools support, and worked directly with the people who rely on them every day. I care about building dependable tools that save real time, and I use <b className="purple"> AI-assisted development </b> to deliver them faster.
            </p>
          </Col>

          <Col
            md={5}
            style={{ paddingTop: "0px", paddingBottom: "20px" }}
            className="about-img">
            <img src={lightbulb} alt="about" height={320} />
          </Col>
        </Row>

        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
